import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";

interface SmsCampaignShortcuts {
    id?: number;
    sms_campaign_id?: number;
    code: string;
    message: string;
    createdAt?: string;
    updatedAt?: string;
}

interface SmsCampaignstViewState {
    smscampaignshortcutsdataview: SmsCampaignShortcuts[];
    info: { count: number; current_page: number; limit: number; total_page: number } | null;
    error: string | null;
    loading: boolean;
}


// // ==================view-Smscampaign-Shortcut-View-api-start=============
export const GetSmsCampaignShortcutsView = createAsyncThunk<
    SmsCampaignShortcuts,
    number,
    { rejectValue: string }
>(
    'smscampaignlistviewsdata/GetSmsCampaignShortcutsView',
    async (id, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(`/api/admin/sms-campaign/shortcut-message/${id}`);
            return response.data.smsShortcutMessage;
        } catch (error: any) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue(error.message);
        }
    }
);
// // ==================view-Smscampaign-Shortcut-View-api-end============

const initialState: SmsCampaignstViewState = {
    smscampaignshortcutsdataview: [],
    info: null,
    error: null,
    loading: false,
};

const smscampaignshortcutsviewSlice = createSlice({
    name: "Smscampaignshortcutview",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(GetSmsCampaignShortcutsView.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(GetSmsCampaignShortcutsView.fulfilled, (state, action: PayloadAction<SmsCampaignShortcuts>) => {
                state.loading = false;
                state.error = null;
                state.smscampaignshortcutsdataview = [action.payload];
            })
            .addCase(GetSmsCampaignShortcutsView.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            });
    },
});

export default smscampaignshortcutsviewSlice.reducer;